
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hairpaca-api",
      function () {
        return require("private-next-pages/hairpaca-api.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hairpaca-api"])
      });
    }
  